import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import Swal from 'sweetalert2'
import { PasswordChange } from '../../CommonAPI/Common'
import { Eye, EyeOff } from 'lucide-react'
import Content from '../../../ExtraComponent/Content'

const Editprofile = () => {
    const userName = localStorage.getItem('name')
    const [currPass, setCurrPass] = useState('')
    const [newPass, setNewPass] = useState('')
    const [verifyPass, setVerifyPass] = useState('')
    const [getCurrentPassError, setCurrentPassError] = useState('')
    const [getNewError, setNewError] = useState('')
    const [getVeryfyError, setVeryfyError] = useState('')
    const [showPass1, setShowPass1] = useState(false)
    const [showPass2, setShowPass2] = useState(false)
    const [showPass3, setShowPass3] = useState(false)

    const handleSubmit = async () => {
        if (getVeryfyError == '' && getNewError == '' && getCurrentPassError == '') {
            const data = { User: userName, new_password: newPass, old_password: currPass, confirm_password: verifyPass }
            await PasswordChange(data)
                .then((response) => {
                    if (response.Status) {
                        Swal.fire({
                             // background: "#1a1e23 ",
                            backdrop: "#121010ba",
                            confirmButtonColor: "#1ccc8a",
                            title: "Success",
                            text: response.message,
                            icon: "success",
                            timer: 1500,
                            timerProgressBar: true
                        });
                    }
                    else {
                        Swal.fire({
                             // background: "#1a1e23 ",
                            backdrop: "#121010ba",
                            confirmButtonColor: "#1ccc8a",
                            title: "Error !",
                            text: response.message,
                            icon: "error",
                            timer: 1500,
                            timerProgressBar: true
                        });
                    }
                })
                .catch((err) => {
                    console.log("Error in finding the response", err)
                })
        }
    }
    const handleCurrentPassword = (e) => {
        const currPass = e.target.value;
        setCurrPass(currPass);
        if (!currPass) {
            setCurrentPassError('Current Password cannot be empty');
        } else {
            setCurrentPassError('');
        }
    };

    const handleNewPassword = (e) => {
        const newPass = e.target.value;
        setNewPass(newPass);
        if (!newPass) {
            setNewError('New Password cannot be empty');
        } else {
            setNewError('');
        }
    };
    const handleVeryfyPassword = (e) => {
        const verifyPass = e.target.value;
        setVerifyPass(verifyPass);
        if (!verifyPass) {
            setVeryfyError('Email cannot be empty');
        } else {
            setVeryfyError('');
        }
    };

    return (
<Content
  Page_title={"📄 Change Password"}
  button_status={false}
  backbutton_status={true}
>
  <div className="container mt-4">
    <div className="row justify-content-center">
      <div className="col-lg-6 col-md-8">
        <div className="card shadow-lg border-0 rounded-3">
          <div className="card-header text-center py-3">
            <h4 className="mb-0"> Change Password</h4>
          </div>
          <div className="card-body p-4">

            {/* Current Password */}
            <div className="mb-3 position-relative">
              <label htmlFor="cpass" className="form-label fw-semibold">
                Current Password
              </label>
              <div className="input-group">
                <input
                  type={showPass1 ? "text" : "password"}
                  className="form-control"
                  id="cpass"
                  placeholder="Enter current password"
                  onChange={handleCurrentPassword}
                  value={currPass}
                />
                <button
                  type="button"
                  className="btn btn-outline-secondary"
                  onClick={() => setShowPass1(!showPass1)}
                >
                  {showPass1 ? <EyeOff /> : <Eye />}
                </button>
              </div>
              {getCurrentPassError && (
                <div className="text-danger small mt-1">
                  {getCurrentPassError}
                </div>
              )}
            </div>

            {/* New Password */}
            <div className="mb-3 position-relative">
              <label htmlFor="npass" className="form-label fw-semibold">
                New Password
              </label>
              <div className="input-group">
                <input
                  type={showPass2 ? "text" : "password"}
                  className="form-control"
                  id="npass"
                  placeholder="Enter new password"
                  onChange={handleNewPassword}
                  value={newPass}
                />
                <button
                  type="button"
                  className="btn btn-outline-secondary"
                  onClick={() => setShowPass2(!showPass2)}
                >
                  {showPass2 ? <EyeOff /> : <Eye />}
                </button>
              </div>
              {getNewError && (
                <div className="text-danger small mt-1">{getNewError}</div>
              )}
            </div>

            {/* Verify Password */}
            <div className="mb-3 position-relative">
              <label htmlFor="vpass" className="form-label fw-semibold">
                Verify Password
              </label>
              <div className="input-group">
                <input
                  type={showPass3 ? "text" : "password"}
                  className="form-control"
                  id="vpass"
                  placeholder="Re-enter new password"
                  onChange={handleVeryfyPassword}
                  value={verifyPass}
                />
                <button
                  type="button"
                  className="btn btn-outline-secondary"
                  onClick={() => setShowPass3(!showPass3)}
                >
                  {showPass3 ? <EyeOff /> : <Eye />}
                </button>
              </div>
              {getVeryfyError && (
                <div className="text-danger small mt-1">{getVeryfyError}</div>
              )}
            </div>

            {/* Buttons */}
            <div className="d-flex justify-content-between mt-4">
              <button
                type="submit"
                className="btn btn-success px-4"
                onClick={handleSubmit}
              >
                 Submit
              </button>
              <Link to={"/user/dashboard"} className="btn btn-danger px-4">
                 Cancel
              </Link>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</Content>
    )
}

export default Editprofile
